import { Component, EventEmitter, input, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CardActionClicked, IInfoCard } from 'src/app/models/api/integration.model';
import { MenuAction } from 'src/app/models/menuAction.model';

@Component({
  selector: 'app-info-card',
  templateUrl: './info-card.component.html',
  styleUrls: ['./info-card.component.scss'],
})
export class InfoCardComponent {
  @Input() public card: IInfoCard;
  public isIntegrationsScansDataFeatureEnabled = input.required<boolean>();

  @Output() public cardOnClick = new EventEmitter<CardActionClicked>();

  constructor(private readonly _router: Router) {}

  public actionOnClick(action: MenuAction) {
    this.cardOnClick.emit({
      card: this.card,
      action: action,
    });

    if (action.shouldOpenDialog) {
      this._router.navigate([], {
        queryParams: this.card.internalNavigation.query,
        queryParamsHandling: 'merge',
      });
    }
  }
}
